import React from "react";
import { Create, SimpleForm, SelectInput, TextInput, BooleanInput, required } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { initialValues, languageChoices, positionType } from "../../../utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import { minContainer } from "customStyles/ra-custom-styles";
import { Grid } from "@mui/material";
const CreateVacantPositions = () => {
  return (
    <Create title="Създаване на свободна позиция">
      <SimpleForm
        defaultValues={initialValues}
        sx={minContainer}
      >
        <Grid container>
          <Grid
            items
            xs={12}
          >
            <SelectInput
              label="Език"
              source="language"
              choices={languageChoices}
              validate={required()}
            />
          </Grid>
          <Grid
            items
            xs={9}
          >
            <TextInput
              label="Заглавие"
              source="title"
              validate={required()}
              fullWidth
              multiline
            />
          </Grid>
          <Grid
            items
            xs={9}
          >
            <TextInput
              label="Населено място"
              source="inhabited_area"
              validate={required()}
              fullWidth
            />
          </Grid>
          <Grid container>
            <Grid
              items
              xs={3}
            >
              <CustomDateInput
                label="Дата на публикуване"
                source="starting_on"
                validate={required()}
              />
            </Grid>
            <Grid
              items
              xs={6}
            >
              <SelectInput
                label="Тип"
                source="type"
                validate={required()}
                choices={positionType}
                defaultValue={1}
                fullWidth
              />
            </Grid>
          </Grid>

          <RichTextInput
            label="Съдържание"
            source="content"
            validate={required()}
            multiline
            fullWidth
          />
          <BooleanInput
            label="Скрита"
            source="is_hidden"
          />
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default CreateVacantPositions;
